module.exports = __webpack_public_path__ + "static/img/parcial.e0b227d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/parcial.png
// module id = 242
// module chunks = 1